import { InvoiceStatus } from '@40seas/entities/invoices';
import { EnumColor } from '@40seas/frontend/common/providers';

export const invoiceStatusColorMapping = {
    [InvoiceStatus.Assigned]: 'info',
    [InvoiceStatus.Canceled]: 'error',
    [InvoiceStatus.Confirmed]: 'info',
    [InvoiceStatus.Charged]: 'success',
    [InvoiceStatus.PartiallyPaid]: 'info',
    [InvoiceStatus.Eligible]: 'info',
    [InvoiceStatus.Expired]: 'error',
    [InvoiceStatus.Defaulted]: 'error',
    [InvoiceStatus.Refunded]: 'default',
    [InvoiceStatus.Pending]: 'default',
    [InvoiceStatus.Overdue]: 'warning',
} as { [key in InvoiceStatus]: EnumColor };
